import { useEffect, useRef } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api, writes } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Polls the location's change version; when another session (or this one) saves, connected views refetch without a manual refresh.
export function useLiveUpdates() {
  const { locationId } = useAuth();
  const qc = useQueryClient();
  const seen = useRef({});
  const q = useQuery({
    queryKey: ["__changes", locationId],
    queryFn: () => api.get("/changes").then((r) => r.data),
    enabled: !!locationId,
    refetchInterval: () => (document.visibilityState === "visible" ? 5000 : false),
    refetchOnWindowFocus: true, refetchOnReconnect: true, retry: false,
  });
  useEffect(() => {
    const v = q.data?.v;
    if (v == null || !locationId) return;
    const prev = seen.current[locationId];
    seen.current[locationId] = v;
    const own = v === (prev ?? -1) + 1 && Date.now() - writes.last < 4000;
    if (prev != null && v > prev && !own) qc.invalidateQueries({ predicate: (x) => x.queryKey[0] !== "__changes" });
  }, [q.data, locationId, qc]);
}
